import { useReact_useEffect_Z101E1A95, useReact_useMemo_CF4EA67, useReact_useReducer_2B9E6EA0, useFeliz_React__React_useState_Static_1505 } from "../fable_modules/Feliz.1.68.0/React.fs.js";
import { ofList } from "../fable_modules/fable-library.3.7.17/Set.js";
import { createObj, int32ToString, compare } from "../fable_modules/fable-library.3.7.17/Util.js";
import { createElement } from "react";
import * as react from "react";
import { Row, Col } from "../../../Components/UtilComponents.fs.js";
import { ofArray, singleton, empty } from "../fable_modules/fable-library.3.7.17/List.js";
import { Gap, MarginLeft, Padding, PaddingLeft, PaddingBottom, PaddingTop, modal, MarginBottom } from "../../../Styles/Utils.fs.js";
import { ErrorText, InfoCheckbox, Info, CibFormChip } from "../../../DesignSystems/DesignSystem.fs.js";
import { MuiHelpers_createElement } from "../fable_modules/Feliz.MaterialUI.1.2.6/./Mui.fs.js";
import Divider from "@material-ui/core/Divider";
import { PartnerId as PartnerId_2, AdiRoleModule_string, VatNumber___UnsafeUnwrap_18C04ACB, PhoneNumber___UnsafeUnwrap_23E45174, Email___UnsafeUnwrap_Z27D11339, Partner__get_LastName, Partner__get_Firstname, NonEmptyString___UnsafeUnwrap_Z73AD07C, PartnerCode___UnsafeUnwrap_786B17C8 } from "../../../shared/Domain.fs.js";
import { map, defaultArg } from "../fable_modules/fable-library.3.7.17/Option.js";
import { join, isNullOrWhiteSpace } from "../fable_modules/fable-library.3.7.17/String.js";
import { Compensation_compensation } from "../../../shared/Format.fs.js";
import RadioGroup from "@material-ui/core/RadioGroup";
import { empty as empty_1, append, singleton as singleton_1, collect, delay, toList } from "../fable_modules/fable-library.3.7.17/Seq.js";
import { DossierSearchTerms, Adi_nameAndRole } from "../../../shared/DomainHelpers.fs.js";
import { AdiCheckbox } from "../../../DesignSystems/partner/PartnerUtils.fs.js";
import { Interop_reactApi } from "../fable_modules/Feliz.1.68.0/./Interop.fs.js";
import ListItem from "@material-ui/core/ListItem";
import List from "@material-ui/core/List";
import Paper from "@material-ui/core/Paper";
import { useSnackbar } from "notistack";
import Modal from "@material-ui/core/Modal";
import Button from "@material-ui/core/Button";
import { startImmediate } from "../fable_modules/fable-library.3.7.17/Async.js";
import { singleton as singleton_2 } from "../fable_modules/fable-library.3.7.17/AsyncBuilder.js";
import { EnqueueSnackbarOption, SnackbarProp_Variant_Z609E1E86, ProviderContext__enqueueSnackbar_Z1776A768 } from "../../../Notistack/Notistack.fs.js";
import { State, searchTerms as searchTerms_1, initialState, update } from "../../../DesignSystems/dossier/DossierFilter.fs.js";
import { useDebouncedValue } from "../../../CustomHooks/CustomHooks.fs.js";
import { useFeliz_React__React_useDeferred_Static_2344FC52 } from "../fable_modules/Feliz.UseDeferred.1.5.0/UseDeferred.fs.js";
import { PagingQuery } from "../../../shared/Paging.fs.js";
import { RouterModule_nav } from "../fable_modules/Feliz.Router.3.10.0/./Router.fs.js";
import { Page$2__toUrl_2B594 } from "../../../BidirectionalRouting/BidirectionalRouting.fs.js";
import { dossierDetail, partnersEdit } from "../AppRoutes.fs.js";
import Edit from "@material-ui/icons/Edit";
import { Auth0UserPrivileges, Auth0UserClaims__HasPrivilege_6B2F319B } from "../../../shared/Auth0Constants.fs.js";
import { Page } from "../components/Page.fs.js";
import { DossiersData } from "../../../DesignSystems/dossier/DossierDetails.fs.js";
import { downloadFile_CSV } from "./DownloadFile.fs.js";
import { DisplayDeferred } from "../../../DesignSystems/DisplayDeferred.fs.js";

export function DisplayPartnerInfo(partnerWithAdis) {
    let children_2, children_1, children, elements_1;
    const partner = partnerWithAdis.Partner;
    const patternInput = useFeliz_React__React_useState_Static_1505(ofList(partnerWithAdis.PartnerAdis, {
        Compare: compare,
    }));
    return createElement(Col, {
        classes: empty(),
        children: ofArray([createElement("h2", {
            children: ["Partnergegevens"],
        }), createElement(Row, {
            classes: singleton(MarginBottom.M),
            children: singleton(createElement(Col, {
                classes: empty(),
                children: singleton(createElement(CibFormChip, {
                    isCibDossier: partner.IsCibPartner,
                    onClick: void 0,
                })),
            })),
        }), (children_2 = singleton((children_1 = ofArray([createElement(Info, {
            secondary: "Partner nummer",
            primary: int32ToString(partner.Id.Value),
        }), MuiHelpers_createElement(Divider, [["component", "li"]]), createElement(Info, {
            secondary: "Code",
            primary: PartnerCode___UnsafeUnwrap_786B17C8(partner.Code),
        }), MuiHelpers_createElement(Divider, [["component", "li"]]), createElement(Info, {
            secondary: "Bedrijfsnaam",
            primary: NonEmptyString___UnsafeUnwrap_Z73AD07C(partner.CompanyName),
        }), MuiHelpers_createElement(Divider, [["component", "li"]]), createElement(Info, {
            secondary: "Commercial Name",
            primary: defaultArg(map(NonEmptyString___UnsafeUnwrap_Z73AD07C, partner.CommercialName), "--"),
        }), MuiHelpers_createElement(Divider, [["component", "li"]]), createElement(Info, {
            secondary: "Bedrijfstype",
            primary: defaultArg(map(NonEmptyString___UnsafeUnwrap_Z73AD07C, partner.CompanyType), "--"),
        }), MuiHelpers_createElement(Divider, [["component", "li"]]), createElement(Info, {
            secondary: "Contact Voornaam",
            primary: isNullOrWhiteSpace(Partner__get_Firstname(partner)) ? "--" : Partner__get_Firstname(partner),
        }), MuiHelpers_createElement(Divider, [["component", "li"]]), createElement(Info, {
            secondary: "Contact Naam",
            primary: isNullOrWhiteSpace(Partner__get_LastName(partner)) ? "--" : Partner__get_LastName(partner),
        }), MuiHelpers_createElement(Divider, [["component", "li"]]), createElement(Info, {
            secondary: "Email",
            primary: Email___UnsafeUnwrap_Z27D11339(partner.Email),
        }), MuiHelpers_createElement(Divider, [["component", "li"]]), createElement(Info, {
            secondary: "Telefoon",
            primary: PhoneNumber___UnsafeUnwrap_23E45174(partner.PhoneNumber),
        }), MuiHelpers_createElement(Divider, [["component", "li"]]), createElement(Info, {
            secondary: "BTW",
            primary: defaultArg(map(VatNumber___UnsafeUnwrap_18C04ACB, partner.VatNumber), "--"),
        }), MuiHelpers_createElement(Divider, [["component", "li"]]), createElement(InfoCheckbox, {
            secondary: "VME",
            state: partner.IsVME,
        }), MuiHelpers_createElement(Divider, [["component", "li"]]), createElement(InfoCheckbox, {
            secondary: "Sociale huisvestigingsmaatschappij",
            state: partner.IsSocialHousingCompany,
        }), MuiHelpers_createElement(Divider, [["component", "li"]]), createElement(Info, {
            secondary: "Vergoedingen",
            primary: defaultArg(map(Compensation_compensation, partner.CompensationAmount), "--"),
        }), MuiHelpers_createElement(Divider, [["component", "li"]]), createElement(Info, {
            secondary: "Straat",
            primary: NonEmptyString___UnsafeUnwrap_Z73AD07C(partner.Address.Street),
        }), MuiHelpers_createElement(Divider, [["component", "li"]]), createElement(Info, {
            secondary: "Nummer",
            primary: NonEmptyString___UnsafeUnwrap_Z73AD07C(partner.Address.Number),
        }), MuiHelpers_createElement(Divider, [["component", "li"]]), createElement(Info, {
            secondary: "Bus",
            primary: defaultArg(map(NonEmptyString___UnsafeUnwrap_Z73AD07C, partner.Address.Bus), "--"),
        }), MuiHelpers_createElement(Divider, [["component", "li"]]), createElement(Info, {
            secondary: "Postcode",
            primary: NonEmptyString___UnsafeUnwrap_Z73AD07C(partner.Address.PostalCode),
        }), MuiHelpers_createElement(Divider, [["component", "li"]]), createElement(Info, {
            secondary: "Gemeente",
            primary: NonEmptyString___UnsafeUnwrap_Z73AD07C(partner.Address.City),
        }), MuiHelpers_createElement(Divider, [["component", "li"]]), createElement(Info, {
            secondary: "Minimum ADI Role",
            primary: defaultArg(map(AdiRoleModule_string, partner.MinimumRole), "-"),
        }), MuiHelpers_createElement(Divider, [["component", "li"]]), createElement(Info, {
            secondary: "Preferred Adis",
            primary: "",
        }), (children = singleton(MuiHelpers_createElement(RadioGroup, [["row", false], (elements_1 = toList(delay(() => collect((adi) => {
            const adiName = Adi_nameAndRole(adi);
            return singleton_1(createElement(AdiCheckbox, {
                label: adiName,
                adiValue: adi,
                values: patternInput[0],
                setAdis: patternInput[1],
                disabled: true,
            }));
        }, partnerWithAdis.PartnerAdis))), ["children", Interop_reactApi.Children.toArray(Array.from(elements_1))])])), MuiHelpers_createElement(ListItem, [["children", Interop_reactApi.Children.toArray(Array.from(children))]]))]), MuiHelpers_createElement(List, [["children", Interop_reactApi.Children.toArray(Array.from(children_1))]]))), MuiHelpers_createElement(Paper, [["children", Interop_reactApi.Children.toArray(Array.from(children_2))]]))]),
    });
}

export function ConfirmCreateAccountModal(confirmCreateAccountModalInputProps) {
    let elems_1, elems;
    const onConfirm = confirmCreateAccountModalInputProps.onConfirm;
    const setShowConfirmModal = confirmCreateAccountModalInputProps.setShowConfirmModal;
    const showConfirmationModal = confirmCreateAccountModalInputProps.showConfirmationModal;
    const snackbar = useSnackbar();
    return MuiHelpers_createElement(Modal, [["open", showConfirmationModal], ["onClose", (_arg_2, v) => {
        setShowConfirmModal(false);
    }], ["children", createElement("div", createObj(ofArray([["className", join(" ", [modal, PaddingTop.L, PaddingBottom.L, PaddingLeft.L])], (elems_1 = [createElement("div", createObj(ofArray([["className", join(" ", [MarginBottom.M, Padding.S])], (elems = [createElement("h3", {
        children: ["Partnerportalaccount maken voor deze partner?"],
    })], ["children", Interop_reactApi.Children.toArray(Array.from(elems))])]))), MuiHelpers_createElement(Button, [["onClick", (_arg_3) => {
        startImmediate(singleton_2.Delay(() => singleton_2.TryFinally(singleton_2.Delay(() => singleton_2.TryWith(singleton_2.Delay(() => {
            onConfirm();
            return singleton_2.Zero();
        }), (_arg) => {
            const e = _arg;
            ProviderContext__enqueueSnackbar_Z1776A768(snackbar, `Een onbekende fout is opgetreden tijdens het bevestigen van de afspraak. Gelieve support te contacteren. [${e.message}]`, SnackbarProp_Variant_Z609E1E86("error"), new EnqueueSnackbarOption(1, false));
            console.log(e);
            return singleton_2.Zero();
        })), () => {
            setShowConfirmModal(false);
        })));
    }], ["className", join(" ", [])], ["variant", "contained"], ["color", "secondary"], ["children", "Ja"]]), MuiHelpers_createElement(Button, [["onClick", (_arg_4) => {
        setShowConfirmModal(false);
    }], ["className", join(" ", [MarginLeft.S])], ["variant", "contained"], ["color", "primary"], ["children", "Nee"]])], ["children", Interop_reactApi.Children.toArray(Array.from(elems_1))])])))]]);
}

export function ConfirmPartnerPortalEmailModal(confirmPartnerPortalEmailModalInputProps) {
    let elems_1, elems;
    const onConfirm = confirmPartnerPortalEmailModalInputProps.onConfirm;
    const setShowConfirmModal = confirmPartnerPortalEmailModalInputProps.setShowConfirmModal;
    const showConfirmationModal = confirmPartnerPortalEmailModalInputProps.showConfirmationModal;
    const snackbar = useSnackbar();
    return MuiHelpers_createElement(Modal, [["open", showConfirmationModal], ["onClose", (_arg_2, v) => {
        setShowConfirmModal(false);
    }], ["children", createElement("div", createObj(ofArray([["className", join(" ", [modal, PaddingTop.L, PaddingBottom.L, PaddingLeft.L])], (elems_1 = [createElement("div", createObj(ofArray([["className", join(" ", [MarginBottom.M, Padding.S])], (elems = [createElement("h3", {
        children: ["Partnerportalaccount maken voor deze partner?"],
    })], ["children", Interop_reactApi.Children.toArray(Array.from(elems))])]))), MuiHelpers_createElement(Button, [["onClick", (_arg_3) => {
        startImmediate(singleton_2.Delay(() => singleton_2.TryFinally(singleton_2.Delay(() => singleton_2.TryWith(singleton_2.Delay(() => {
            onConfirm();
            return singleton_2.Zero();
        }), (_arg) => {
            const e = _arg;
            ProviderContext__enqueueSnackbar_Z1776A768(snackbar, `Een onbekende fout is opgetreden tijdens het bevestigen van de afspraak. Gelieve support te contacteren. [${e.message}]`, SnackbarProp_Variant_Z609E1E86("error"), new EnqueueSnackbarOption(1, false));
            console.log(e);
            return singleton_2.Zero();
        })), () => {
            setShowConfirmModal(false);
        })));
    }], ["className", join(" ", [])], ["variant", "contained"], ["color", "secondary"], ["children", "Ja"]]), MuiHelpers_createElement(Button, [["onClick", (_arg_4) => {
        setShowConfirmModal(false);
    }], ["className", join(" ", [MarginLeft.S])], ["variant", "contained"], ["color", "primary"], ["children", "Nee"]])], ["children", Interop_reactApi.Children.toArray(Array.from(elems_1))])])))]]);
}

export function RenderPartnerDetail(renderPartnerDetailInputProps) {
    let props, children_1;
    const auth0User = renderPartnerDetailInputProps.auth0User;
    const partnerWithAdis = renderPartnerDetailInputProps.partnerWithAdis;
    const api = renderPartnerDetailInputProps.api;
    const currentPage = renderPartnerDetailInputProps.currentPage;
    const partnerDetails = partnerWithAdis.Partner;
    const snackbar = useSnackbar();
    const patternInput = useReact_useReducer_2B9E6EA0(update, initialState);
    const state_1 = patternInput[0];
    const search = useDebouncedValue(500, useReact_useMemo_CF4EA67(() => searchTerms_1(state_1), [state_1]));
    const data = useFeliz_React__React_useDeferred_Static_2344FC52(api.GetPartnerDossiersDetails(new PagingQuery(state_1.PageNumber, state_1.PageSize), new DossierSearchTerms(search.DossierCode, search.PartnerName, search.AdiName, search.CustomerName, search.Address, search.PhoneNumber, search.Status, search.StartDate, search.EndDate, search.FilterOutDossiersWithoutPartners, search.CibFilter, search.CustomerCode, search.PartnerPortal, search.Urgent, partnerDetails.Id, search.PartnerIdList)), [state_1.PageNumber, state_1.PageSize, search]);
    const patternInput_1 = useFeliz_React__React_useState_Static_1505(false);
    const setShowPPActivationEmailButton = patternInput_1[1];
    useReact_useEffect_Z101E1A95(() => {
        startImmediate(singleton_2.Delay(() => singleton_2.TryWith(singleton_2.Delay(() => singleton_2.Bind(api.CheckPartnerPortalActivationEmailStatus(partnerDetails.Email), (_arg_1) => {
            const result = _arg_1;
            if (result.tag === 1) {
                setShowPPActivationEmailButton(false);
                return singleton_2.Zero();
            }
            else {
                setShowPPActivationEmailButton(!result.fields[0]);
                return singleton_2.Zero();
            }
        })), (_arg_2) => {
            setShowPPActivationEmailButton(false);
            return singleton_2.Zero();
        })));
    }, []);
    const patternInput_2 = useFeliz_React__React_useState_Static_1505(false);
    const setCreateAccountModal = patternInput_2[1];
    const patternInput_3 = useFeliz_React__React_useState_Static_1505(false);
    const setShowPpEmailModal = patternInput_3[1];
    const patternInput_4 = useFeliz_React__React_useState_Static_1505(false);
    const setDisableCreateAccount = patternInput_4[1];
    const editPartnerButton = MuiHelpers_createElement(Button, [["onClick", (_arg_3) => {
        RouterModule_nav(ofArray(Page$2__toUrl_2B594(partnersEdit, partnerDetails.Id.Value)), 1, 1);
    }], ["variant", "contained"], ["color", "secondary"], ["startIcon", (props = {}, react.createElement(Edit, props))], ["children", "Partner bewerken"]]);
    const createAccountButton = MuiHelpers_createElement(Button, [["disabled", patternInput_4[0]], ["onClick", (_arg_9) => {
        setCreateAccountModal(true);
    }], ["variant", "contained"], ["color", "secondary"], ["children", "Partner portaal activeren"]]);
    const showCreateAccountButton = (partnerDetails.TenantPartnerCustomerId == null) && (Auth0UserClaims__HasPrivilege_6B2F319B(auth0User, new Auth0UserPrivileges(0)));
    const sendPartnerPortalActivationEmailButton = MuiHelpers_createElement(Button, [["disabled", !patternInput_1[0]], ["onClick", (_arg_10) => {
        setShowPpEmailModal(true);
    }], ["variant", "contained"], ["color", "secondary"], ["children", "Partner portaal activeren"]]);
    const buttons = createElement(Row, {
        classes: singleton(Gap.Xs),
        children: toList(delay(() => append((!showCreateAccountButton) ? singleton_1(sendPartnerPortalActivationEmailButton) : empty_1(), delay(() => append(showCreateAccountButton ? singleton_1(createAccountButton) : empty_1(), delay(() => singleton_1(editPartnerButton))))))),
    });
    return createElement(Page, {
        currentPage: currentPage,
        title: "",
        actions: [buttons],
        children: [createElement(Col, {
            classes: singleton(Gap.S),
            children: ofArray([createElement(DisplayPartnerInfo, partnerWithAdis), createElement(ConfirmCreateAccountModal, {
                showConfirmationModal: patternInput_2[0],
                setShowConfirmModal: setCreateAccountModal,
                onConfirm: () => {
                    startImmediate(singleton_2.Delay(() => singleton_2.TryWith(singleton_2.Delay(() => {
                        setDisableCreateAccount(true);
                        return singleton_2.Bind(api.BootstrapPartner(partnerDetails.Id), (_arg_5) => {
                            const result_1 = _arg_5;
                            if (result_1.tag === 1) {
                                const e_3 = result_1.fields[0];
                                console.log(e_3);
                                ProviderContext__enqueueSnackbar_Z1776A768(snackbar, `Een onbekende fout is opgetreden. Gelieve support te contacteren.[${e_3}]`, SnackbarProp_Variant_Z609E1E86("error"), new EnqueueSnackbarOption(1, false));
                                return singleton_2.Zero();
                            }
                            else {
                                (() => {
                                    ProviderContext__enqueueSnackbar_Z1776A768(snackbar, "Geactiveerd partner portaal", SnackbarProp_Variant_Z609E1E86("success"), new EnqueueSnackbarOption(1, false));
                                })();
                                return singleton_2.Zero();
                            }
                        });
                    }), (_arg_6) => {
                        const e_4 = _arg_6;
                        setDisableCreateAccount(false);
                        console.log(e_4);
                        ProviderContext__enqueueSnackbar_Z1776A768(snackbar, `Een onbekende fout is opgetreden. Gelieve support te contacteren.[${e_4.message}]`, SnackbarProp_Variant_Z609E1E86("error"), new EnqueueSnackbarOption(1, false));
                        return singleton_2.Zero();
                    })));
                },
            }), createElement(ConfirmPartnerPortalEmailModal, {
                showConfirmationModal: patternInput_3[0],
                setShowConfirmModal: setShowPpEmailModal,
                onConfirm: () => {
                    startImmediate(singleton_2.Delay(() => singleton_2.TryWith(singleton_2.Delay(() => {
                        setShowPPActivationEmailButton(false);
                        return singleton_2.Bind(api.SendPartnerPortalActivationEmail(partnerDetails.Id), (_arg_7) => {
                            const result_2 = _arg_7;
                            if (result_2.tag === 1) {
                                const e_5 = result_2.fields[0];
                                console.log(e_5);
                                ProviderContext__enqueueSnackbar_Z1776A768(snackbar, `Een onbekende fout is opgetreden. Gelieve support te contacteren.[${e_5}]`, SnackbarProp_Variant_Z609E1E86("error"), new EnqueueSnackbarOption(1, false));
                                return singleton_2.Zero();
                            }
                            else {
                                (() => {
                                    ProviderContext__enqueueSnackbar_Z1776A768(snackbar, "Activeringsmail voor partnerportaal verzonden", SnackbarProp_Variant_Z609E1E86("success"), new EnqueueSnackbarOption(1, false));
                                })();
                                return singleton_2.Zero();
                            }
                        });
                    }), (_arg_8) => {
                        const e_6 = _arg_8;
                        setShowPPActivationEmailButton(true);
                        console.log(e_6);
                        ProviderContext__enqueueSnackbar_Z1776A768(snackbar, `Een onbekende fout is opgetreden. Gelieve support te contacteren.[${e_6.message}]`, SnackbarProp_Variant_Z609E1E86("error"), new EnqueueSnackbarOption(1, false));
                        return singleton_2.Zero();
                    })));
                },
            }), createElement("h2", {
                children: ["Gekoppelde dossiers"],
            }), (children_1 = singleton(createElement(DossiersData, {
                data: data,
                state: new State(state_1.DossierCode, state_1.AdiName, state_1.PartnerName, state_1.CustomerName, state_1.CustomerCode, state_1.Address, state_1.PhoneNumber, state_1.DateRange, partnerDetails.Id, state_1.Status, state_1.PageNumber, state_1.PageSize, state_1.CibFilter, state_1.PartnerPortal, state_1.Urgent),
                dispatch: patternInput[1],
                url: (dossierId) => Page$2__toUrl_2B594(dossierDetail, dossierId.Value),
                showPartnerName: false,
                optionalExportCsvFunction: (query) => ((searchTerms) => {
                    startImmediate(singleton_2.Delay(() => singleton_2.TryWith(singleton_2.Delay(() => {
                        startImmediate(downloadFile_CSV(api, query, searchTerms));
                        return singleton_2.Zero();
                    }), (_arg_4) => {
                        ProviderContext__enqueueSnackbar_Z1776A768(snackbar, `Een onbekende fout is opgetreden. Gelieve support te contacteren. [${_arg_4.message}]`, SnackbarProp_Variant_Z609E1E86("error"), new EnqueueSnackbarOption(1, false));
                        return singleton_2.Zero();
                    })));
                }),
                showCibFilter: false,
                isBackOffice: true,
                klantNameHeader: void 0,
            })), MuiHelpers_createElement(Paper, [["children", Interop_reactApi.Children.toArray(Array.from(children_1))]]))]),
        })],
    });
}

export function PartnerDetail(partnerDetailInputProps) {
    const partnerType = partnerDetailInputProps.partnerType;
    const auth0User = partnerDetailInputProps.auth0User;
    const partnerId = partnerDetailInputProps.partnerId;
    const api = partnerDetailInputProps.api;
    const currentPage = partnerDetailInputProps.currentPage;
    const data = useFeliz_React__React_useDeferred_Static_2344FC52(api.GetPartnerWithAdis(new PartnerId_2(partnerId)), []);
    return createElement(DisplayDeferred, {
        data: data,
        view: (partnerDetails) => {
            if (partnerDetails == null) {
                return createElement(Page, {
                    currentPage: currentPage,
                    title: "",
                    actions: [],
                    children: [createElement(ErrorText, {
                        text: `Geen partner gevonden met ID ${partnerId}`,
                    })],
                });
            }
            else {
                const partnerDetails_1 = partnerDetails;
                return createElement(RenderPartnerDetail, {
                    currentPage: currentPage,
                    api: api,
                    partnerWithAdis: partnerDetails_1,
                    auth0User: auth0User,
                });
            }
        },
    });
}

